import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { FileText, Download, Phone, Send } from 'lucide-react';
import { CONTACT, BUYERS_GUIDES } from '../data/constants';

const brochures = [
  // Buyers Guides (top)
  { name: 'Hot Tub Buyers Guide', file: BUYERS_GUIDES.hotTub, category: 'Buyers Guide', brand: 'Leisure Wellness Naples' },
  { name: 'Sauna Buyers Guide', file: BUYERS_GUIDES.sauna, category: 'Buyers Guide', brand: 'Leisure Wellness Naples' },

  // Full Catalogs
  { name: '2025 Dynasty Full Brochure', file: '/brochures/2025_DYNASTY_FULL_BROCHURE.pdf', category: 'Full Catalog', brand: 'Dynasty Spas' },
  { name: 'Viking Spas Full Brochure', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf', category: 'Full Catalog', brand: 'Viking Spas' },
  { name: 'Grand River Spas 2025 Brochure', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf', category: 'Full Catalog', brand: 'Grand River Spas' },
  
  // Collections
  { name: 'Family Collection', file: '/brochures/FAMILY_COLLECTION_PRODUCT_SHEET.pdf', category: 'Collection', brand: 'Dynasty Spas' },
  { name: 'Swim Spa Collection', file: '/brochures/SWIM_SPA_COLLECTION_PRODUCT_SHEET.pdf', category: 'Collection', brand: 'Dynasty Spas' },
  
  // Viking Spas - Elite Series
  { name: 'Heritage I', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=8', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Heritage II', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=8', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Tradition I', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=9', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Tradition II', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=9', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Apex I', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=10', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Apex II', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=10', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Ascent I', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=11', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Ascent II', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=11', category: 'Viking Spas', brand: 'Viking Spas' },
  
  // Viking Spas - Heirloom Series
  { name: 'Royale', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=13', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Royale ETS', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=13', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Regal', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=13', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Regal ETS', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=13', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Aurora 3', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=14', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Viking 3', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=14', category: 'Viking Spas', brand: 'Viking Spas' },
  
  // Viking Spas - Plug N' Play Series
  { name: 'Royale P+', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=16', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Regal P+', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=16', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Aurora P+', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=17', category: 'Viking Spas', brand: 'Viking Spas' },
  { name: 'Viking 2P', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/vmpqiwb2_Viking-Spas-Brochure_Rev-C_web.pdf#page=17', category: 'Viking Spas', brand: 'Viking Spas' },
  
  // Grand River Spas - Premier Series
  { name: 'Saginaw 1', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=8', category: 'Grand River Spas', brand: 'Grand River Spas' },
  { name: 'Saginaw 2', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=8', category: 'Grand River Spas', brand: 'Grand River Spas' },
  { name: 'Thornapple 1', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=9', category: 'Grand River Spas', brand: 'Grand River Spas' },
  { name: 'Thornapple 2', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=9', category: 'Grand River Spas', brand: 'Grand River Spas' },
  { name: 'Muskegon 1', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=10', category: 'Grand River Spas', brand: 'Grand River Spas' },
  { name: 'Muskegon 2', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=10', category: 'Grand River Spas', brand: 'Grand River Spas' },
  { name: 'Sturgeon 1', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=11', category: 'Grand River Spas', brand: 'Grand River Spas' },
  { name: 'Sturgeon 2', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=11', category: 'Grand River Spas', brand: 'Grand River Spas' },
  { name: 'Manistee', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=12', category: 'Grand River Spas', brand: 'Grand River Spas' },
  
  // Grand River Spas - Eco Series
  { name: 'Sturgeon Eco', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=15', category: 'Grand River Spas', brand: 'Grand River Spas' },
  { name: 'Manistee Eco', file: 'https://customer-assets.emergentagent.com/job_family-spa-luxury/artifacts/cdko0u59_GR-2025_Brochure_RevA_Update_E_Final_6.16_final_email.pdf#page=15', category: 'Grand River Spas', brand: 'Grand River Spas' },
  
  // Dynasty Spas - Hot Tubs (alphabetical)
  { name: 'Bay Bliss', file: '/brochures/BAY+BLISS+PRODUCT+SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Bimini', file: '/brochures/BIMINI_2_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Cabana Bay', file: '/brochures/CABANA_BAY_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Caribbean Breeze', file: '/brochures/CARIBBEAN_BREEZE_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Coconut Bay', file: '/brochures/COCONUT_BAY_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'High Tide', file: '/brochures/HIGH+TIDE+PRODUCT+SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Nassau Royale', file: '/brochures/NASSAU_ROYALE_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Ocean Breeze', file: '/brochures/OCEAN_BREEZE_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Palm Island', file: '/brochures/PALM_ISLAND_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Paradise Bay', file: '/brochures/PARADISE_BAY_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Pleasure Cove', file: '/brochures/PLEASURE_COVE_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Seaside', file: '/brochures/SEASIDE+PRODUCT+SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Serenity Cove', file: '/brochures/SERENITY_COVE_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Sunset Cove', file: '/brochures/SUNSET_COVE_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Tranquility Harbor', file: '/brochures/TRANQUILITY_HARBOR_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Treasure Cay', file: '/brochures/TREASURE_CAY_PRODUCT_SHEET.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
  { name: 'Twin Palms', file: '/brochures/TWIN_PALMS_PRODUCT_SHEET-5ab8b7c0.pdf', category: 'Dynasty Spas', brand: 'Dynasty Spas' },
];

const ContactForm = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', interest: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    try {
      await fetch('/', { 
        method: 'POST', 
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, 
        body: new URLSearchParams(data).toString() 
      });
      setSubmitted(true);
    } catch (error) { 
      console.error('Form error:', error); 
    }
  };

  if (submitted) {
    return (
      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }} 
        animate={{ scale: 1, opacity: 1 }} 
        className="bg-green-50 border border-green-200 p-8 text-center"
      >
        <div className="text-green-600 text-5xl mb-4">✓</div>
        <h3 className="font-['Barlow_Condensed'] text-2xl font-bold text-green-800 mb-2">Thank You!</h3>
        <p className="text-green-700">We've received your request and will be in touch soon!</p>
      </motion.div>
    );
  }

  return (
    <form 
      name="brochure-request" 
      method="POST" 
      data-netlify="true" 
      netlify-honeypot="bot-field" 
      onSubmit={handleSubmit} 
      className="space-y-4"
    >
      <input type="hidden" name="form-name" value="brochure-request" />
      <p className="hidden"><label>Don't fill this out: <input name="bot-field" /></label></p>
      
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="name" className="block text-sm font-semibold text-[#0A1628] mb-1">Full Name *</label>
          <input 
            type="text" 
            id="name" 
            name="name" 
            required 
            className="w-full px-4 py-3 border border-slate-300 focus:border-[#F88200] focus:ring-1 focus:ring-[#F88200] outline-none transition-colors" 
            value={formData.name} 
            onChange={e => setFormData({...formData, name: e.target.value})} 
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-semibold text-[#0A1628] mb-1">Email *</label>
          <input 
            type="email" 
            id="email" 
            name="email" 
            required 
            className="w-full px-4 py-3 border border-slate-300 focus:border-[#F88200] focus:ring-1 focus:ring-[#F88200] outline-none transition-colors" 
            value={formData.email} 
            onChange={e => setFormData({...formData, email: e.target.value})} 
          />
        </div>
      </div>
      
      <div>
        <label htmlFor="phone" className="block text-sm font-semibold text-[#0A1628] mb-1">Phone</label>
        <input 
          type="tel" 
          id="phone" 
          name="phone" 
          className="w-full px-4 py-3 border border-slate-300 focus:border-[#F88200] focus:ring-1 focus:ring-[#F88200] outline-none transition-colors" 
          value={formData.phone} 
          onChange={e => setFormData({...formData, phone: e.target.value})} 
        />
      </div>
      
      <div>
        <label htmlFor="interest" className="block text-sm font-semibold text-[#0A1628] mb-1">I'm Interested In</label>
        <select 
          id="interest" 
          name="interest" 
          className="w-full px-4 py-3 border border-slate-300 focus:border-[#F88200] focus:ring-1 focus:ring-[#F88200] outline-none transition-colors"
          value={formData.interest}
          onChange={e => setFormData({...formData, interest: e.target.value})}
        >
          <option value="">Select an option</option>
          <option value="hot-tub">Hot Tub</option>
          <option value="pdc-spas">PDC Spas</option>
          <option value="swim-spa">Swim Spa</option>
          <option value="sauna">Sauna</option>
          <option value="cold-plunge">Cold Plunge</option>
          <option value="full-catalog">Full Product Catalog</option>
          <option value="other">Other</option>
        </select>
      </div>
      
      <div>
        <label htmlFor="message" className="block text-sm font-semibold text-[#0A1628] mb-1">Message</label>
        <textarea 
          id="message" 
          name="message" 
          rows="3" 
          className="w-full px-4 py-3 border border-slate-300 focus:border-[#F88200] focus:ring-1 focus:ring-[#F88200] outline-none transition-colors resize-none" 
          placeholder="Tell us about what you're looking for..."
          value={formData.message} 
          onChange={e => setFormData({...formData, message: e.target.value})}
        />
      </div>
      
      <button 
        type="submit" 
        className="w-full bg-[#F88200] hover:bg-[#e07600] text-white font-bold py-3 px-6 transition-colors inline-flex items-center justify-center gap-2"
      >
        <Send size={18} />
        Request More Information
      </button>
    </form>
  );
};

const BrochurePage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  
  const categories = ['all', 'Buyers Guide'];
  
  const visibleBrochures = brochures.filter(b => b.brand !== 'Dynasty Spas' && b.brand !== 'Viking Spas' && b.brand !== 'Grand River Spas');
  const filteredBrochures = selectedCategory === 'all' 
    ? visibleBrochures 
    : visibleBrochures.filter(b => b.category === selectedCategory);

  // Get brand color for card styling
  const getBrandColor = (brand) => {
    switch(brand) {
      case 'Viking Spas': return 'bg-[#002868]/10 group-hover:bg-[#002868]';
      case 'Grand River Spas': return 'bg-[#0E3D95]/10 group-hover:bg-[#0E3D95]';
      case 'Dynasty Spas': return 'bg-[#F88200]/10 group-hover:bg-[#F88200]';
      case 'Leisure Wellness Naples': return 'bg-emerald-100 group-hover:bg-emerald-600';
      default: return 'bg-[#F88200]/10 group-hover:bg-[#F88200]';
    }
  };

  const getBrandTextColor = (brand) => {
    switch(brand) {
      case 'Viking Spas': return 'text-[#002868] group-hover:text-white';
      case 'Grand River Spas': return 'text-[#0E3D95] group-hover:text-white';
      case 'Dynasty Spas': return 'text-[#F88200] group-hover:text-white';
      case 'Leisure Wellness Naples': return 'text-emerald-700 group-hover:text-white';
      default: return 'text-[#F88200] group-hover:text-white';
    }
  };

  return (
    <>
      <Helmet>
        <title>Product Brochures | Buyers Guides | Leisure Wellness Naples</title>
        <meta name="description" content="Download free hot tub and sauna buyers guides from Leisure Wellness Naples. Get detailed specifications and features for our American-made wellness products." />
      </Helmet>

      <div className="pt-36 pb-20" style={{
        background: 'linear-gradient(180deg, #ffffff 0%, #E0FFFF 20%, #AFEEEE 50%, #98FB98 80%, #F0FFF0 100%)'
      }}>
        {/* Hero */}
        <div className="relative bg-gradient-to-r from-[#0E3D95] to-[#0A1628] text-white py-12 mb-8">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl">🇺🇸</span>
                <span className="text-sm font-semibold text-[#F88200] uppercase tracking-wider">American Made & Proud of It</span>
              </div>
              <h1 className="font-['Barlow_Condensed'] text-4xl md:text-6xl font-bold uppercase mb-4">
                Product Brochures
              </h1>
              <p className="text-xl text-slate-300 max-w-2xl">
                Download our free buyers guides to explore hot tubs, saunas, cold plunges, swim spas, and more.
              </p>
            </motion.div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Brochures Section */}
            <div className="lg:col-span-2">
              {/* Category Filter */}
              <div className="flex flex-wrap gap-2 mb-6">
                {categories.map(cat => (
                  <button
                    key={cat}
                    onClick={() => setSelectedCategory(cat)}
                    className={`px-4 py-2 font-semibold transition-colors rounded ${
                      selectedCategory === cat 
                        ? 'bg-[#F88200] text-white' 
                        : 'bg-white text-slate-700 hover:bg-slate-100'
                    }`}
                  >
                    {cat === 'all' ? 'All Brochures' : cat}
                  </button>
                ))}
              </div>

              {/* Brochure Grid */}
              <div className="grid sm:grid-cols-2 gap-4">
                {filteredBrochures.map((brochure, idx) => (
                  <motion.a
                    key={`${brochure.name}-${idx}`}
                    href={brochure.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.03 }}
                    className="bg-white p-4 flex items-center gap-4 hover:shadow-lg transition-shadow group rounded-lg"
                  >
                    <div className={`w-12 h-12 ${getBrandColor(brochure.brand)} flex items-center justify-center flex-shrink-0 transition-colors rounded`}>
                      <FileText className={`${getBrandTextColor(brochure.brand)} transition-colors`} size={24} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-semibold text-[#0A1628] truncate">{brochure.name}</h3>
                      <p className="text-sm text-slate-500">{brochure.brand}</p>
                    </div>
                    <Download className="text-slate-400 group-hover:text-[#F88200] transition-colors flex-shrink-0" size={20} />
                  </motion.a>
                ))}
              </div>
              
              {/* Featured Buyers Guides */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
                className="mt-8 space-y-4"
                data-testid="featured-buyers-guides"
              >
                <div className="bg-gradient-to-r from-emerald-50 via-emerald-100 to-white p-6 md:p-8 rounded-lg border-2 border-emerald-300">
                  <div className="flex items-center gap-2 mb-3">
                    <FileText className="text-emerald-700" size={28} />
                    <h2 className="font-['Barlow_Condensed'] text-2xl md:text-3xl font-bold text-emerald-800">
                      Free Buyers Guides
                    </h2>
                  </div>
                  <p className="text-slate-600 mb-5">
                    Confused by the options? Download our free, no-pressure Buyers Guides written by the wellness experts at Leisure Wellness Naples.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <a
                      href={BUYERS_GUIDES.hotTub}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 inline-flex items-center justify-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-3 px-6 transition-colors rounded"
                      data-testid="download-hot-tub-guide-brochures"
                    >
                      <Download size={20} />
                      Hot Tub Buyers Guide (PDF)
                    </a>
                    <a
                      href={BUYERS_GUIDES.sauna}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 inline-flex items-center justify-center gap-2 bg-[#F88200] hover:bg-[#e07600] text-white font-bold py-3 px-6 transition-colors rounded"
                      data-testid="download-sauna-guide-brochures"
                    >
                      <Download size={20} />
                      Sauna Buyers Guide (PDF)
                    </a>
                  </div>
                </div>
              </motion.div>

              {/* Featured Full Catalogs */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="mt-8 space-y-4"
              >
              </motion.div>
            </div>

            {/* Contact Form Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-white p-6 shadow-lg sticky top-32 rounded-lg">
                <h2 className="font-['Barlow_Condensed'] text-2xl font-bold text-[#0A1628] mb-2">
                  Request More Information
                </h2>
                <p className="text-slate-600 mb-6 text-sm">
                  Want a printed brochure mailed to you or have questions? Fill out the form below!
                </p>
                
                <ContactForm />

                {/* Phone Contact */}
                <div className="mt-6 pt-6 border-t border-slate-200">
                  <p className="text-sm text-slate-600 mb-2">Or call us directly:</p>
                  <a 
                    href={`tel:${CONTACT.phone}`}
                    className="inline-flex items-center gap-2 text-[#F88200] font-bold text-lg hover:underline"
                  >
                    <Phone size={20} />
                    {CONTACT.phone}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrochurePage;
